export default class BaseComponent {
    constructor() {
        this.hasFunction( 'onScroll' ) && this._bindListener( 'scroll', this._onScroll );
        this.hasFunction( 'onResize' ) && this._bindListener( 'resize', this._onResize, window );
    }

    hasFunction(name, isPrivate = true) {
        let fn = (isPrivate ? '_' : '') + name;

        return typeof this[fn] === 'function';
    }

    _bindListener(type, callback, object = document) {
        $(object).on( type, callback.bind(this) );
    }
}